// getters
const academicCourse = state => state.academicCourse

export default {
    academicCourse
}



// WEBPACK FOOTER //
// ./src/store/modules/academic/courses/getters.js